import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faHeart } from "@fortawesome/free-solid-svg-icons"

export const Heart = (props) => {
  return <FontAwesomeIcon faIcon={faHeart} {...props} />
}
